


























import Vue from "vue";

export default Vue.extend({
  name: "InfoCard",
  props: {
    appCount: { type: Number, default: 0 },
    userCount: { type: Number, default: 0 },
    pipelineCount: { type: Number, default: 0 }
  },
  data() {
    return {};
  }
});
